import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentcolor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M43.481 52.308c0 .908-.778 1.687-1.687 1.687-.908 0-1.686-.779-1.686-1.687v-21.6c0-.908.778-1.687 1.686-1.687.909 0 1.687.779 1.687 1.687zm-9.86 0c0 .908-.777 1.687-1.686 1.687s-1.686-.779-1.686-1.687v-21.6c0-.908.778-1.687 1.686-1.687.909 0 1.686.779 1.686 1.687zm-9.859 0c0 .908-.778 1.687-1.686 1.687-.909 0-1.687-.779-1.687-1.687v-21.6c0-.908.778-1.687 1.687-1.687.908 0 1.686.779 1.686 1.687zM53.34 17.865H10.53A2.49 2.49 0 0 0 8 20.395a2.49 2.49 0 0 0 2.53 2.53h1.167v34.638a5.066 5.066 0 0 0 5.06 5.058h30.421c2.79 0 5.06-2.27 5.06-5.058V22.924h1.102c1.427 0 2.53-1.103 2.53-2.53s-1.103-2.53-2.53-2.53M31.935 4.373a4.66 4.66 0 0 1 4.281 2.789c-1.427-.065-2.854-.13-4.28-.13-1.493 0-2.92.065-4.282.13a4.66 4.66 0 0 1 4.281-2.79M9.751 14.817H54.12c1.686 0 2.4-2.27.908-3.178-3.568-2.27-8.951-3.568-15.178-4.152C39.07 3.79 35.827 1 31.935 1S24.8 3.79 24.022 7.42c-6.227.584-11.611 1.946-15.179 4.152-1.492.973-.843 3.243.908 3.243" })
    ], -1)
  ]))]))
}
export default { render: render }